import API from "../../utils/endpoints";
import * as types from "./actionType";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import history from "../../history";
import { getAuthenticationCookie } from "../../utils/authentication";
import axios from "axios";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingVinLookup() {
  return {
    type: types.FETCH_VIN_LOOKUP,
  };
}

function fetchingVinLookupSuccess(payload) {
  return {
    type: types.FETCH_VIN_LOOKUP_SUCCESS,
    payload,
  };
}

function fetchingVinLookupFailed() {
  return {
    type: types.FETCH_VIN_LOOKUP_FAILED,
  };
}

function changingOwnershipTransfer() {
  return {
    type: types.CHANGE_OWNERSHIP_TRANSFER,
  };
}

function changingOwnershipTransferSuccess(payload) {
  return {
    type: types.CHANGE_OWNERSHIP_TRANSFER_SUCCESS,
    payload,
  };
}

function changingOwnershipTransferFailed() {
  return {
    type: types.CHANGE_OWNERSHIP_TRANSFER_FAILED,
  };
}

function fetchingAllUser() {
  return {
    type: types.FETCH_ALL_USERS,
  };
}

function fetchingAllUserSuccess(payload) {
  return {
    type: types.FETCH_ALL_USERS_SUCCESS,
    payload,
  };
}

function fetchingAllUserFailed() {
  return {
    type: types.FETCH_ALL_USERS_FAILED,
  };
}

function fetchingTransferModerationListing() {
  return {
    type: types.FETCH_TRANSFER_MODERATION_LISTING,
  };
}

function fetchingTransferModerationListingSuccess(payload) {
  return {
    type: types.FETCH_TRANSFER_MODERATION_LISTING_SUCCESS,
    payload,
  };
}

function fetchingTransferModerationListingFailed() {
  return {
    type: types.FETCH_TRANSFER_MODERATION_LISTING_FAILED,
  };
}

function fetchingTransferModerationDetailListing() {
  return {
    type: types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING,
  };
}

function fetchingTransferModerationDetailListingSuccess(payload) {
  return {
    type: types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING_SUCCESS,
    payload,
  };
}

function fetchingTransferModerationDetailListingFailed() {
  return {
    type: types.FETCH_TRANSFER_MODERATION_DETAIL_LISTING_FAILED,
  };
}

function transferModeration() {
  return {
    type: types.TRANSFER_MODERATION,
  };
}

function transferModerationSuccess(payload) {
  return {
    type: types.TRANSFER_MODERATION_SUCCESS,
    payload,
  };
}

function transferModerationFailed() {
  return {
    type: types.TRANSFER_MODERATION_FAILED,
  };
}

function uploadUrlRequest() {
  return {
    type: types.UPLOAD_URL,
  };
}

function uploadUrlSuccess(payload) {
  return {
    type: types.UPLOAD_URL_SUCCESS,
    payload,
  };
}

function uploadUrlFailed() {
  return {
    type: types.UPLOAD_URL_FAILED,
  };
}

function readUrlRequest() {
  return {
    type: types.READ_URL,
  };
}

function readUrlSuccess(payload) {
  return {
    type: types.READ_URL_SUCCESS,
    payload,
  };
}

function readUrlFailed() {
  return {
    type: types.READ_URL_FAILED,
  };
}

function uploadBinaryUrlRequest() {
  return {
    type: types.UPLOAD_BINARY_URL,
  };
}

function uploadBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadBinaryUrlFailed() {
  return {
    type: types.UPLOAD_BINARY_URL_FAILED,
  };
}

export const clearReducer = () => {
  return {
    type: types.CLEAR_REDUCER_VIN_LOOKUP,
  };
};

export const fetchVinLookup = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingVinLookup());
  try {
    let response = await api.get(`${API.fetchVinLookup}?vin=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingVinLookupSuccess([response.data.data]));
    } else {
      dispatch(fetchingVinLookupFailed());
    }
  } catch (error) {
    dispatch(fetchingVinLookupFailed(errorMessage));
  }
};

export const changeOwnershipTransfer = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(changingOwnershipTransfer());
  try {
    const { accessToken } = await getAuthenticationCookie();
    let response = await api.post(API.ownershipTransfer, payload);
    console.log("payyy", payload);
    if (response.data.code === 200) {
      dispatch(changingOwnershipTransferSuccess(response.data.data));
      toast.error(response.data.message);
      window.location.reload();
    } else {
      dispatch(changingOwnershipTransferFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(changingOwnershipTransferFailed(errorMessage));
  }
};

export const fetchAllUser = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllUser());
  try {
    let response = await api.get(
      `${API.fetchAllUser}?page=${payload.page}&phone=${payload.phone}&email=${payload.email}&limit=${payload.limit}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingAllUserSuccess(response.data.data));
    } else {
      dispatch(fetchingAllUserFailed());
    }
  } catch (error) {
    dispatch(fetchingAllUserFailed(errorMessage));
  }
};

export const fetchTransferModerationListing = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingTransferModerationListing());
  try {
    let response = await api.get(
      `${API.fetchTransferModerationListing}?status=${payload.status}&email=${payload.email}&mobile=${payload.phone}&page=${payload.page}&limit=${payload.count}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingTransferModerationListingSuccess({
          data: response.data.data,
          count: response.data.count,
        })
      );
    } else {
      dispatch(fetchingTransferModerationListingFailed());
    }
  } catch (error) {
    dispatch(fetchingTransferModerationListingFailed(errorMessage));
  }
};

export const fetchTransferModerationDetailListing = (payload) => async (
  dispatch,
  getState,
  api
) => {
  console.log("pay", payload);
  dispatch(fetchingTransferModerationDetailListing());
  try {
    let response = await api.get(
      `${API.vehicleTransferDetails}?vehicleId=${payload._id}&userID=${payload.userID._id}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingTransferModerationDetailListingSuccess({
          data: response.data.data,
        })
      );
    } else {
      dispatch(fetchingTransferModerationDetailListingFailed());
    }
  } catch (error) {
    dispatch(fetchingTransferModerationDetailListingFailed(errorMessage));
  }
};

export const moderationTransfer = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(transferModeration());
  try {
    let response = await api.post(API.transferModeration, payload);
    if (response.data.code === 200) {
      dispatch(transferModerationSuccess(response.data.data));
      toast.error(response.data.message);
      dispatch(
        fetchTransferModerationListing({
          status: payload.currentStatus,
          page: payload.page,
          count: payload.count,
          email: payload.email,
          phone: payload.phone,
        })
      );
    } else {
      dispatch(transferModerationFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(transferModerationFailed(errorMessage));
  }
};

export const uploadUrl = (payload) => async (dispatch, getState, api) => {
  dispatch(uploadUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: "userTransfer",
    });
    if (response.data.code === 200) {
      dispatch(uploadUrlSuccess(response.data.data));
      dispatch(uploadBinaryUrl(response.data.data, payload));
    } else {
      dispatch(uploadUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadUrlFailed(errorMessage));
  }
};

export const uploadBinaryUrl = (data, payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadBinaryUrlSuccess(response.data.data));
      dispatch(readUrl(data.filePath));
    } else {
      dispatch(uploadBinaryUrlFailed());
    }
  } catch (error) {
    dispatch(uploadBinaryUrlFailed(errorMessage));
  }
};

export const readUrl = (payload) => async (dispatch, getState, api) => {
  dispatch(readUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readUrlSuccess(newData));
    } else {
      dispatch(readUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readUrlFailed(errorMessage));
  }
};
